/** هل نعمل داخل تطبيق سطح المكتب (Tauri) أم في متصفّح؟ */
export function isTauri(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window
}

const DEVICE_KEY_STORAGE = 'najah.deviceKey'

/**
 * معرّف ثابت لهذا الجهاز. يدخل في أرقام الفواتير، فيضمن ألّا يُنتج جهازان
 * نفس الرقم وهما دون اتصال — بلا حاجة إلى تنسيق مع الخادم.
 */
export function getDeviceKey(): string {
  try {
    const existing = localStorage.getItem(DEVICE_KEY_STORAGE)
    if (existing) return existing
    const key = `dev-${crypto.randomUUID()}`
    localStorage.setItem(DEVICE_KEY_STORAGE, key)
    return key
  } catch {
    // تخزين معطّل: معرّف مؤقّت يعيش مع الصفحة فقط
    return `dev-ephemeral-${crypto.randomUUID()}`
  }
}
